import Nullstack from 'nullstack';
export default function IconWheelchair({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-wheelchair",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "8",
    cy: "16",
    r: "5"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M19 17a3 3 0 0 0 -3 -3h-3.4"
  }), "   ", Nullstack.element("path", {
    d: "M3 3h1a2 2 0 0 1 2 2v6"
  }), "   ", Nullstack.element("path", {
    d: "M6 8h11"
  }), "   ", Nullstack.element("path", {
    d: "M15 8v6"
  }), " ");
}